import { C } from "../data";
import Footer from "./Footer";
import { DEFAULT_INFO_CONTENT } from "../api";

export default function InfoPage({ type, nav, infoContent }) {
  const data = infoContent || DEFAULT_INFO_CONTENT;
  const info = data[type] || DEFAULT_INFO_CONTENT[type] || DEFAULT_INFO_CONTENT.contact;

  return (
    <>
      {/* PAGE HEADER */}
      <div style={{ paddingTop: 'var(--header-h, 60px)', background: C.bg }}>
        <div style={{ maxWidth: 1440, margin: "0 auto", padding: "56px 48px 40px", borderBottom: `1px solid ${C.border}` }}>
          <p style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 5, color: C.accent, marginBottom: 10, textTransform: "uppercase" }}>
            {info.title}
          </p>
          <h1 style={{ fontFamily: "'DM Serif Display',serif", fontSize: "clamp(32px,5vw,60px)", fontWeight: 400, lineHeight: 1.05, color: C.ink }}>
            {info.sub}
          </h1>
        </div>
      </div>

      {/* CONTENT */}
      <div style={{ maxWidth: 800, margin: "0 auto", padding: "64px 48px 96px" }}>
        {info.sections.map(({ heading, body }, i) => (
          <div key={i} style={{ marginBottom: 48, paddingBottom: 48, borderBottom: `1px solid ${C.border}` }}>
            <p style={{ fontFamily: "'Presentation5',sans-serif", fontWeight:500, fontSize: 10, letterSpacing: 3, color: C.ink, textTransform: "uppercase", marginBottom: 14 }}>
              {heading}
            </p>
            <p style={{ fontFamily: "'Presentation5',sans-serif", fontSize: 14, fontWeight: 300, color: C.muted, lineHeight: 2.2, whiteSpace: "pre-line" }}>
              {body}
            </p>
          </div>
        ))}
      </div>

      <Footer nav={nav} variant="full" />
    </>
  );
}
